import { useEffect, useRef } from "react";

import { Button } from "antd";
import { clsx } from "clsx";
import { useSelector } from "react-redux";

import { RVIcon, RVIconSizeOptions } from "@regal-voice/ui";
import { selectEditedNode, selectEditingJourneyDetails } from "Services/state/journeys/JourneyStateSlice";

// @todo replace with shared version
// @see "Components/elements/RVFlow/Components/NodesPanel/NodesPanel";
import { JourneyNodesPanel } from "./JourneyNodesPanel/JourneyNodesPanel";
// @see "Components/elements/RVFlow/Components/NodePropertiesEditor/NodePropertiesEditor";
import { NodeEditorPanel } from "./NodeEditorPanel/NodeEditorPanel";

import styles from "./JourneyActionsPanel.module.scss";

export function JourneyActionsPanel({
    onCollapse,
    onExpand,
    expanded,
    loading = false,
    isViewOnly = false,
    showExecutionMonitor = false,
    onCloseExecutionMonitor,
}: {
    onCollapse: () => void;
    onExpand: () => void;
    expanded: boolean;
    loading?: boolean;
    isViewOnly?: boolean;
    showExecutionMonitor?: boolean;
    onCloseExecutionMonitor?: () => void;
}): JSX.Element {
    const editedNode = useSelector(selectEditedNode);
    const editingJourneyDetails = useSelector(selectEditingJourneyDetails);
    const showExpandPanel = !loading && (expanded || editingJourneyDetails || showExecutionMonitor);

    const prevEditedNodeIdRef = useRef(editedNode?.id);
    useEffect(() => {
        if (editedNode && editedNode.id !== prevEditedNodeIdRef.current && showExecutionMonitor) {
            onCloseExecutionMonitor?.();
        }
        prevEditedNodeIdRef.current = editedNode?.id;
    }, [editedNode, showExecutionMonitor, onCloseExecutionMonitor]);

    return (
        <>
            {showExpandPanel ? (
                <aside className={clsx(styles.actionsPanel, "flex-column")}>
                    {editedNode && editedNode.type && !showExecutionMonitor ? (
                        <NodeEditorPanel
                            key={editedNode.id}
                            id={editedNode.id}
                            type={editedNode.type}
                            isViewOnly={isViewOnly}
                        />
                    ) : (
                        <JourneyNodesPanel
                            onTitleClick={onCollapse}
                            showExecutionMonitor={showExecutionMonitor}
                            onCloseExecutionMonitor={onCloseExecutionMonitor}
                        />
                    )}
                </aside>
            ) : (
                <Button
                    type="text"
                    className={styles.collapseIconButton}
                    icon={<RVIcon icon="page-collapser-left" size={RVIconSizeOptions.BUTTON} />}
                    onClick={onExpand}
                />
            )}
        </>
    );
}
